<template>
  <v-sheet class="bg-blue-darken-4 py-16">
    <v-container>
      <v-row class="mb-6" justify="center">
        <v-col class="text-center" cols="12" md="8">
          <h2 class="text-h5 text-sm-h4 font-weight-medium">
            {{ course.name }}
          </h2>

          <TitleParagraphBlock
            v-if="value.title || value.paragraph"
            em-class-title="text-decoration-underline"
            :value="value"
          />
        </v-col>
      </v-row>

      <v-row v-if="course.note_paragraph" class="mb-6">
        <v-col>
          <v-alert color="surface-light" theme="light" type="info">
            <StyledText
              :value="course.note_paragraph"
              em-class="text-decoration-underline"
            />
          </v-alert>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col
          v-for="item in items"
          :key="item.key"
          class="text-center pb-8"
          cols="12"
          sm="6"
          lg="3"
        >
          <v-avatar
            v-if="typeof item.icon === 'string'"
            class="mb-6"
            size="70"
            style="border-width: 2px"
            rounded="0"
            variant="outlined"
          >
            <v-icon :icon="`hdl:${item.icon}`" size="44" />
          </v-avatar>

          <h3 class="text-h5 font-weight-medium mb-4">{{ item.title }}</h3>

          <ContentBlock
            :value="item"
            class="text-body-1 text-left"
            em-class="font-weight-black"
        /></v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script setup>
import { computed } from 'vue'

const ITEM_KEYS = [
  'features_item',
  'learn_item',
  'why_item',
  'earn_item',
  'who_item',
  'bonus_item'
]

const props = defineProps({
  course: {
    required: true,
    type: Object
  },
  value: {
    required: true,
    type: Object
  }
})

const items = computed(() => {
  return ITEM_KEYS.map(key => {
    return Object.assign({ key }, props.value[key], props.course[key])
  }).filter(item => item.list || item.paragraph)
})
</script>
